import { useSelector } from 'react-redux';
import { selectHouseShortAddress, selectPageTitle } from 'shared/selectors/houseInfo';
import { FactoidsContainer, NewbuildingInfoContainer, TransportAccessibilityContainer } from './containers';
import { Head } from 'shared/components/Head';
import { Section } from 'shared/components/Section';
import { PanoramaContainer } from '../PanoramaContainer';

export const HeadContainer = () => {
  const title = useSelector(selectPageTitle);
  const locationInfo = useSelector(selectHouseShortAddress);

  return (
    <Section>
      <Head
        title={title}
        newbuildingInfo={<NewbuildingInfoContainer />}
        location={locationInfo}
        transportDistance={<TransportAccessibilityContainer />}
        panorama={<PanoramaContainer />}
        factoids={<FactoidsContainer />}
      />
    </Section>
  );
};
